import { ChevronDown } from "lucide-react";

export default function Hero({ t }) {
  const handleScroll = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-[100svh] min-h-[640px] w-full overflow-hidden bg-[#0A0A0A]"
    >
      {/* Video background */}
      <video
        className="absolute inset-0 h-full w-full object-cover opacity-70"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src="/assets/hero/setubal-hero.webm" type="video/webm" />
      </video>

      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-[#0A0A0A]/30 to-[#0A0A0A]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_0%,_rgba(10,10,10,0.5)_100%)]" />

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10 h-full flex flex-col justify-end pb-20 lg:pb-32">
        <div className="max-w-3xl">
          <div
            data-testid="hero-eyebrow"
            className="flex items-center gap-4 mb-6 animate-fade-up"
          >
            <span className="h-px w-10 bg-[#BEAF87]" />
            <span className="text-[11px] uppercase tracking-[0.35em] text-[#BEAF87] font-[Barlow_Semi_Condensed]">
              {t.hero.eyebrow}
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-[Cormorant_Garamond] font-light text-white leading-[0.95] tracking-tight text-[64px] sm:text-[88px] lg:text-[128px] animate-fade-up"
            style={{ animationDelay: "80ms" }}
          >
            {t.hero.title}
            <span className="block italic text-[#BEAF87] font-light">
              {t.hero.titleAccent}
            </span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-8 text-white/80 max-w-xl text-base sm:text-lg leading-relaxed font-[Barlow_Semi_Condensed] animate-fade-up"
            style={{ animationDelay: "160ms" }}
          >
            {t.hero.subtitle}
          </p>

          <div
            className="mt-10 flex flex-wrap items-center gap-4 animate-fade-up"
            style={{ animationDelay: "240ms" }}
          >
            <button
              data-testid="hero-cta-primary"
              onClick={() => handleScroll("#contact")}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#BEAF87] text-[#0A0A0A] text-[12px] uppercase tracking-[0.25em] font-medium hover:bg-[#d4c59a] transition-all duration-300 hover:-translate-y-0.5"
            >
              {t.hero.ctaPrimary}
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => handleScroll("#typologies")}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/40 text-white text-[12px] uppercase tracking-[0.25em] hover:border-[#BEAF87] hover:text-[#BEAF87] transition-all duration-300"
            >
              {t.hero.ctaSecondary}
            </button>
          </div>
        </div>

        {/* Scroll indicator */}
        <button
          data-testid="hero-scroll-indicator"
          onClick={() => handleScroll("#about")}
          className="absolute bottom-8 right-6 lg:right-10 flex flex-col items-center gap-2 text-white/60 hover:text-[#BEAF87] transition-colors"
        >
          <span className="text-[10px] uppercase tracking-[0.3em] font-[Barlow_Semi_Condensed]">
            {t.hero.scroll}
          </span>
          <ChevronDown size={18} className="animate-bounce" />
        </button>
      </div>
    </section>
  );
}
